import { call, put, takeLatest } from 'redux-saga/effects';
import { DistributionActionTypes } from './distributionTypes';
import { distributionApiResponseSuccess, distributionApiResponseError } from './distributionActions';
import { generateApi } from '../api/distillNode';

function* generateSaga(action: any): any {
  try {
    const response = yield call(generateApi, action.payload);
    const data = response.data ?? response;
    yield put(
      distributionApiResponseSuccess(DistributionActionTypes.GENERATE, {
        outputs: data.outputs,
        angle: action.payload.angle,
      }),
    );
  } catch (error: any) {
    yield put(
      distributionApiResponseError(
        DistributionActionTypes.GENERATE,
        error?.response?.data?.error || error?.message || 'Generate failed',
      ),
    );
  }
}

export default function* distributionSaga() {
  yield takeLatest(DistributionActionTypes.GENERATE, generateSaga);
}
